<template>
  <material-card-sba
    :size.sync="internalSize"
    :order.sync="internalOrder"
    :height.sync="internalHeight"
    :maxOrderValue="maxOrderValue"
    color="accent"
    :widgetIcon="widgetIcon"
    :title="
      $t('components.vue_material_dashboard.items.external_pension.title')
    "
  >
    <v-row no-gutters class="fill-height mx-2" justify="space-around">
      <v-col cols="12" class="mt-8" v-if="summary">
        <template v-if="summary.HasStatement">
          <v-col class="pa-0 title1 text-uppercase">
            {{
              $t(
                "components.vue_material_dashboard.items.external_pension.monthly_pension"
              )
            }}
          </v-col>
          <v-col class="pa-0 text-h6 font-weight-bold accent--text">
            {{ $helpers.toCurrency(summary.MonthlyPension) }}
          </v-col>
          <v-col class="pa-0 mt-4 text-subtitle-2 font-weight-bold info--text">
            {{
              $t("components.external_pension.as_at", [
                $helpers.formatDate(summary.AsAtDate),
              ])
            }}
          </v-col>
        </template>
        <v-col v-else class="pa-0 text-subtitle-2">
          {{
            $t(
              "components.vue_material_dashboard.items.external_pension.no_statement"
            )
          }}
        </v-col>
      </v-col>
      <v-btn color="accent" class="action-btn" to="/external-pension">
        {{ $t("globals.view_details") }}
      </v-btn>
      <v-progress-circular
        v-show="loading"
        size="50"
        class="loader"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </material-card-sba>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MaterialCardSba from "@/components/VueMaterialDashboard/material/MaterialCardSbaDashboard.vue";
export default {
  components: {
    MaterialCardSba,
  },
  props: {
    widgetId: String,
    widgetIcon: String,
    size: Number,
    height: Number,
    order: Number,
    maxOrderValue: Number,
  },
  data() {
    return {
      internalSize: undefined,
      internalOrder: undefined,
      internalHeight: undefined,
      loading: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("externalPension", ["summary"]),
  },
  watch: {
    size: {
      handler(v) {
        this.internalSize = v;
      },
    },
    internalSize: {
      handler(v) {
        this.$emit("update:size", v);
      },
    },
    height: {
      handler(v) {
        this.internalHeight = v;
      },
    },
    internalHeight: {
      handler(v) {
        this.$emit("update:height", v);
      },
    },
    order: {
      handler(v) {
        this.internalOrder = v;
      },
    },
    internalOrder: {
      handler(v) {
        this.$emit("update-order", v);
      },
    },
  },
  async mounted() {
    if (this.size !== null && this.size !== undefined) {
      this.internalSize = this.size;
    }
    if (this.height !== null && this.height !== undefined) {
      this.internalHeight = this.height;
    }
    if (this.order !== null && this.order !== undefined) {
      this.internalOrder = this.order;
    }
    try {
      this.loading = true;
      await this.loadSummary(this.user.drawbridgeMemberId);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions("externalPension", ["loadSummary"]),
  },
};
</script>
<style scoped>
.title1 {
  font-size: 12px;
  font-weight: 600;
}
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.action-btn {
  position: absolute;
  bottom: 24px;
  right: 24px;
}
</style>
